import { Button } from "@/components/ui/Button";
import { ArrowDown } from "lucide-react";

// Constants
const BUTTON_JUMP = "Jump to latest message";

/**
 * JumpToBottomButton component
 *
 * Displays a floating button that allows users to quickly scroll to the latest messages
 * when they've scrolled up to view older messages.
 *
 * The button is only shown when users are not already at the bottom of the chat,
 * as determined by the `show` prop.
 *
 * @param onClick - Callback function that scrolls the chat to the bottom
 * @param show - Boolean indicating whether the button should be visible
 */
interface JumpToBottomButtonProps {
  onClick: () => void;
  show: boolean;
}

export const JumpToBottomButton = ({
  onClick,
  show,
}: JumpToBottomButtonProps) => {
  // Don't render anything if the button shouldn't be shown
  if (!show) return null;

  return (
    // This div is used to anchor it at the top of the chat input but has
    // a height of 0 to prevent it from pushing the chat content up.
    <div className="relative h-0 left-0 right-0 flex justify-center">
      <Button
        onClick={onClick}
        variant="secondary"
        className="shadow-md h-10 bottom-12"
        aria-label={BUTTON_JUMP}
      >
        <div className="flex items-center gap-2">
          {BUTTON_JUMP}
          <ArrowDown size={12} />
        </div>
      </Button>
    </div>
  );
};
